<template>
    <v-card v-if="items.length" class="pa-0">
        <v-card-title class="font-weight-bold py-2">
            <v-icon left color="primary" class="mr-1">mdi-school-outline</v-icon>
            <span style="font-size: 15px;">Training Progress</span>
        </v-card-title>
        <v-divider class="my-0"></v-divider>

        <v-list dense class="py-0">
            <v-list-item v-for="t in items" :key="t.id" style="border-bottom: 1px solid #eee;" @click="$refs.progressModal.open(t.id)">
                <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{ t.title }}</v-list-item-title>
                    <v-list-item-subtitle v-if="t.provider">{{ t.provider }}</v-list-item-subtitle>
                    <div class="d-flex flex-wrap align-center mt-1">
                        <v-progress-linear
                            :value="t.percent"
                            :color="t.percent == 100 ? 'green' : 'primary'"
                            height="8"
                            rounded
                            class="mr-3"
                            style="max-width: 260px;"
                        ></v-progress-linear>
                        <span class="caption text-no-wrap mr-3">
                            <strong>{{ t.done }}</strong> of {{ t.total }} completed ({{ t.percent }}%)
                        </span>
                        <span v-if="t.due_date" class="caption grey--text text--darken-1 text-no-wrap">
                            Due {{ $localeDate(t.due_date) }}
                        </span>
                    </div>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn x-small outlined color="primary" @click.stop="$refs.progressModal.open(t.id)">view staff</v-btn>
                </v-list-item-action>
            </v-list-item>
        </v-list>

        <training-progress-modal ref="progressModal"></training-progress-modal>
    </v-card>
</template>

<script>
import TrainingProgressModal from '../staff-training/TrainingProgressModal.vue'

// Trainings HR marked "Show progress on staff dashboard". Renders nothing when
// no training is shared. Emits `loaded` with the count so the dashboard can
// collapse its column.
export default {
    components: { TrainingProgressModal },
    data: () => ({
        items: [],
    }),
    methods: {
        getItems() {
            this.$axios.get('/api/staff-training/progress', { silentError: true }).then((resp) => {
                this.items = resp.data
            }).catch(() => {
                this.items = []
            }).finally(() => {
                this.$emit('loaded', this.items.length)
            })
        },
    },
    mounted() {
        this.getItems()
    },
}
</script>
